export default function initScrollSlide() {
  window.addEventListener('load', () => {
    const slides = document.querySelectorAll('.scroll-slides')
    const activeZones = document.querySelectorAll(
      '.box-list-active-zones .active-zone'
    )
    const listItems = document.querySelectorAll('.box-scroll-into-view ul li')

    if (!slides.length || !activeZones.length || !listItems.length) {
      return
    }

    let prevActiveIndex = -1

    const updateActiveSlide = () => {
      const windowCenter = window.innerHeight / 2
      let activeIndex = -1
      let foundZone = false

      activeZones.forEach((zone, index) => {
        const rect = zone.getBoundingClientRect()

        if (windowCenter >= rect.top) {
          activeIndex = index
          foundZone = true
        }
      })

      if (activeIndex === -1) {
        activeIndex = 0
        foundZone = true
      }

      if (foundZone) {
      } else {
      }

      if (prevActiveIndex !== activeIndex) {
        listItems.forEach((item, index) => {
          item.classList.remove('active', 'prev')

          if (index < activeIndex) {
            item.classList.add('prev')
          } else if (index === activeIndex) {
            item.classList.add('active')
            updateClasses(activeIndex)
          }
        })
      }

      prevActiveIndex = activeIndex
    }

    const updateClasses = (activeIndex) => {
      const targetClass = `item-card-${activeIndex}`

      slides.forEach((slide) => {
        slide.classList.remove('active')
        if (slide.classList.contains(targetClass)) {
          slide.classList.add('active')
        }
      })

      activeZones.forEach((zone, index) => {
        zone.classList.remove('active', 'prev')

        if (index < activeIndex) {
          zone.classList.add('prev')
        } else if (index === activeIndex) {
          zone.classList.add('active')
        }
      })
    }

    window.addEventListener('scroll', updateActiveSlide)
    window.addEventListener('resize', updateActiveSlide)
    updateActiveSlide()
  })
}
